// Add other variants of the logo here
export const ELogoVariant = {
  Default: 'default',
} as const;

// Creates a union type of string literals from ELogoVariant values
// e.g., "default",
export type TLogoVariantString =
  (typeof ELogoVariant)[keyof typeof ELogoVariant];

export interface ILogoProps {
  type?: TLogoVariantString;
  size?: number;
  className?: string;
}

export interface ISvgProps {
  size?: number;
  className?: string;
}
